module.exports = __webpack_public_path__ + "img/eye-in-client-leduc.e28a2810.webp";